import type { AnySchema } from 'yup';
import { mixed } from 'yup';

export const validateSchemaIfTrueValue = (schema: AnySchema): AnySchema => {
  return mixed()
    .nullable()
    .test('validate-schema-if-true', '', async function validateIfTrueValueFunction(value) {
      if (!value) {
        return true;
      }
      try {
        await schema.validate(value, { context: this.options.context });
        return true;
      } catch (err) {
        return this.createError({ message: err.message });
      }
    });
};
